<template>
    <div>
        <b-modal
            id="export-process-popup"
            ref="modal"
            size="sm"
            modal-class="hide-footer"
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
            :hide-header-close="loading"
            @hidden="hideModal"
        >
            <div slot="modal-header" class="w-100 archive-popup">
                <h5 class="modal-title">{{ title }}</h5>
            </div>
            <div class="export-process custom-model-form">
                <excel-icon></excel-icon>
                <label>Total Records Exported: {{ totalRecords }}</label>
                <div class="loading">
                    <img :src="require('@/assets/images/loader.svg')" />
                </div>
                <p>
                    Your data is being exported now. Once this process completed
                    we will send you report via email.
                </p>
            </div>
            <div class="col-md-12 action-buttons">
                <button
                    class="btn btn-primary"
                    type="submit"
                    @click="hideModal"
                >
                    <span class="btn-text">CLOSE</span>
                </button>

                <button
                    class="btn btn-link"
                    type="reset"
                    @click="cancelExportProcess"
                >
                    <span class="btn-text">Cancel Export Process</span>
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import excelIcon from '@/components/icons/ExcelIcon.vue'
import request from '@/utils/request'

export default {
    components: {
        excelIcon,
    },
    props: {
        id: {
            type: Number,
            default: null,
        },
        title: {
            type: String,
            default: null,
            required: true,
        },
        url: {
            type: String,
            default: null,
            required: true,
        },
    },
    computed: {
        ...mapGetters(['loading', 'totalRecords']),
    },
    methods: {
        hideModal() {
            this.$refs['modal'].hide()
            this.$store.commit(`setTotalRecords`, null)
        },

        async cancelExportProcess() {
            let self = this
            try {
                let { data } = await request.post(this.url, {
                    id: this.id,
                })

                this.$toasted.show(data.message, {
                    type: 'error',
                })
                setTimeout(function() {
                    self.$refs.modal.hide()
                }, 2000)
            } catch (error) {
                // console.log(error, 'error')
            }
        },
    },
}
</script>
